import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import CompletedSection from './components/CompletedSection';
import CTASection from './components/CTASection';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="奇妙漫画 | 韩漫日漫国漫免费全集 | 热门推荐漫画类型大全下拉式阅读"
        description="奇妙漫画汇集海量韩漫、日漫、国漫类型，热门推荐漫画免费全集在线看，支持下拉式连续阅读，手机流畅滚动体验。"
        url="https://www.qimiaomanhua.com"
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <HotRecommendSection />
        <LatestUpdateSection />
        <CompletedSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}